import styled from 'styled-components';

export const ConsumerUnitCardContainer = styled.div<{
  active: boolean;
}>`
  background-color: ${(props) => props.theme.color.bg.primary};
  position: relative;
  border-style: ${(props) => (props.active ? 'solid' : 'none')};
  border-width: 2px;
  border-color: ${(props) => props.theme.color.ui.primary};
  border-radius: 3px;

  /* Alvo ao arrastar para reordenar o carrossel (out/2026) */
  &.drag-over {
    outline: 2px dashed ${(props) => props.theme.color.ui.primary};
    outline-offset: 2px;
  }
  width: 320px;
  /* height: 296px; */
  overflow: hidden;
  &:hover {
    div:nth-child(1) {
      opacity: 1;
    }
    div:nth-child(4) {
      bottom: 0;
    }
  }
`;

export const Icon = styled.img`
  position: relative;
  top: -2px;
`;

export const SelectConsumerUnit = styled.div`
  background: ${(props) => props.theme.color.bg.primary};
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  opacity: 0;
  span {
    color: ${(props) => props.theme.color.text.quaternary};
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
  }
  .form-check-input {
    border: 1px solid #999999;
    box-shadow: 0 0 1px #f79422;
    /* background-color: ${(props) => props.theme.color.bg.primary};
    border: 1px solid ${(props) => props.theme.color.ui.primary}; */
    &:checked {
      background-color: ${(props) => props.theme.color.ui.primary};
      border: 1px solid ${(props) => props.theme.color.ui.primary};
    }
  }
  .form-check-label {
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    color: ${(props) => props.theme.color.text.primary};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
  }
`;

export const SelectConsumerUnitCheckbox = styled.div`
  width: 16px;
  height: 16px;
  display: block;
  border: 1px solid ${(props) => props.theme.color.text.quaternary};
  border-radius: 3px;
`;

export const CardImage = styled.div`
  position: relative;
  width: 320px;
  height: 160px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

// Estrela de favorito no canto da foto (out/2026)
export const FavouriteSlot = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 1;
`;

export const Company = styled.div`
  width: 64px;
  height: 64px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => props.theme.color.bg.primary};
  border-radius: 50%;
  position: absolute;
  top: 149px;
  right: 8px;
`;

export const CompanyImg = styled.img`
  max-width: 48px;
  max-height: 48px;
`;

export const InfoTitle = styled.p`
  color: ${(props) => props.theme.color.text.tertiary};
  font-size: 20px;
  font-family: Poppins;
  font-weight: 700;
  line-height: 1.2;
  /* O círculo do logo cobre o fim da linha: nome longo termina em reticências
     antes dele (nov/2026); o nome inteiro fica no title. */
  max-width: calc(100% - 44px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const InfoAddress = styled.p`
  color: ${(props) => props.theme.color.text.primary};
  font-size: 14px;
  font-family: Montserrat;
  line-height: normal;
`;

// inline-block + nowrap: cada dado quebra de linha inteiro, sem cortar
// "1/10 fatura(s)" no meio (revisão de UX, out/2026).
export const InfoData = styled.span`
  display: inline-block;
  white-space: nowrap;
  color: ${(props) => props.theme.color.text.quaternary};
  font-size: 14px;
  font-family: Montserrat;
`;

export const InfoDataWarning = styled.span<{ hasError: boolean }>`
  display: inline-block;
  white-space: nowrap;
  color: ${(props) =>
    !props.hasError
      ? props.theme.color.text.quaternary
      : props.theme.color.text.danger};
  font-size: 14px;
  font-family: Montserrat;
`;

// Mini-métricas consumo × créditos (26/out/2026 — opção B do Bruno; antes
// "58.948kWh" ia na linha do R$ e "Créditos: X kWh" numa linha solta). Rótulo
// pequeno com ícone em cinza e valor em negrito, mesma fonte do card.
export const Metrics = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  margin-top: 10px;
  padding-top: 8px;
  border-top: 1px solid ${(props) => props.theme.color.ui.shade2};
  font-family: Montserrat;
`;

export const Metric = styled.div`
  min-width: 0;
  cursor: default;
`;

export const MetricLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: ${(props) => props.theme.color.text.quaternary};

  img {
    top: 0;
  }
  svg {
    color: #999999;
  }
`;

export const MetricValue = styled.span`
  display: block;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => props.theme.color.text.primary};
`;

export const CreditHighTag = styled.span`
  margin-left: 2px;
  font-size: 11px;
  font-weight: 600;
  color: #1345b0;
  background: #f2f2f2;
  border-radius: 3px;
  padding: 1px 8px;
`;

// Sem width: 100% (26/out/2026): somado à margem esquerda (ms-4 ps-2) o bloco
// passava da largura do card e "9/10 fatura(s)" era cortado em vez de quebrar
// para a linha de baixo.
export const CardDataContainer = styled.div`
  padding-right: 16px;
`;

export const OptionsContainer = styled.div`
  width: 320px;
  border-top: 1px solid ${(props) => props.theme.color.ui.shade2};
  /* background-color: red; */
  /* background-color: ${(props) => props.theme.color.bg.primary}; */
  /* position: absolute; */
  /* bottom: -62px; */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

// Botão de verdade (out/2026): era div clicável — fora do teclado e do leitor
// de tela. Cada uso leva aria-label + title.
export const Option = styled.button`
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  background-color: ${(props) => props.theme.color.bg.primary};
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:hover {
    background: ${(props) => props.theme.color.bg.muted};
  }
  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.color.ui.orange};
  }
`;

export const OptionImg = styled.img`
  max-width: 16px;
  max-height: 16px;
`;

export const ModalHeader = styled.div`
  background: #333;
  svg {
    cursor: pointer;
  }
`;

export const ModalHeaderSection = styled.p`
  color: ${(props) => props.theme.color.text.secondary};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

export const ModalHeaderTitle = styled.p`
  color: ${(props) => props.theme.color.text.inverse};
  font-family: Poppins;
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const ModalContent = styled.div``;

export const ModalTable = styled.table`
  width: 100%;
  font-family: Montserrat;
  font-style: normal;
  cursor: default;
  th,
  td {
    height: 60px;
  }
  thead {
    font-size: 14px;
    font-weight: 700;
    line-height: normal;
    color: ${(props) => props.theme.color.text.secondary};
    th {
      &:nth-of-type(1) {
        text-align: center;
        width: 120px;
      }
      &:nth-of-type(3),
      &:nth-of-type(4),
      &:nth-of-type(5),
      &:nth-of-type(6) {
        text-align: center;
      }
    }
  }
  tbody {
    font-size: 16px;
    font-weight: 400;
    line-height: 23px;
    color: #333;
    tr {
      &:hover {
        backgroung: ${(props) => props.theme.color.bg.muted};
        td {
          &:nth-of-type(6),
          &:nth-of-type(7) {
            /* opacity: 1; */
          }
        }
      }
      td {
        text-align: center;
        &:nth-of-type(1) {
          width: 100px;
        }
        &:nth-of-type(2) {
          text-align: left;
        }
        &:nth-of-type(6),
        &:nth-of-type(7) {
        }
        &:nth-of-type(8) {
          span {
            cursor: pointer;
            color: ${(props) => props.theme.color.bg.tertiary};
            font-family: Montserrat;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            text-decoration-line: underline;
            margin-right: 8px;
          }
          img {
            position: relative;
            top: -2px;
            cursor: pointer;
          }
        }
      }
    }
  }
`;

export const LabelContainer = styled.div``;

export const Label = styled.label`
  display: block;
  color: ${(props) => props.theme.color.text.disabled};
  font-size: 14px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Select = styled.select`
  border: none;
  border-bottom: 1px solid ${(props) => props.theme.color.bg.muted};
  background: ${(props) => props.theme.color.bg.primary};
  box-shadow: 0px 0px 0px 0px #cbdafc;
  height: 38px;
  font-size: 16px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  width: 235px;
  &::placeholder {
    color: ${(props) => props.theme.color.bg.muted};
  }
  &:focus {
    outline: none;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const Pagination = styled.div`
  border-radius: 3px;
  background: var(--shade-0, #fff);
  display: inline-flex;
  justify-content: center;
`;

export const PaginationButton = styled.div`
  padding: 10px 12px;
  font-family: Montserrat;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 23px;
  color: ${(props) => props.theme.color.text.tertiary};
  display: inline-block;
  border: 1px solid ${(props) => props.theme.color.bg.muted};
  border-right: none;
  cursor: pointer;
  &:first-of-type {
    border-radius: 3px 0 0 3px;
  }
  &:last-of-type {
    border-right: 1px solid ${(props) => props.theme.color.bg.muted};
    border-radius: 0 3px 3px 0;
  }
  &.active,
  &:hover {
    background: ${(props) => props.theme.color.bg.tertiary};
    color: ${(props) => props.theme.color.text.inverse};
  }
`;

export const Status = styled.div<{ isPending: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  width: 100px;
  /* height: 30px; */
  background-color: ${(props) =>
    props.isPending
      ? props.theme.color.ui.redAlt
      : props.theme.color.ui.darkGreen};

  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  padding: 6px 0;
  border-radius: 3px;
`;

export const UploadInvoiceButton = styled.div`
  background-color: ${(props) => props.theme.color.ui.primary};
  font-family: ${(props) => props.theme.font.body.family};
  font-size: ${(props) => props.theme.font.body.size.small};
  color: ${(props) => props.theme.color.text.inverse};
  font-weight: ${(props) => props.theme.font.body.weight.bold};
  padding: 6px 0;
  border-radius: 3px;
`;
